import type { RouteRecordRaw } from 'vue-router';
import {
    redirectToDefaultSettingsView,
    redirectToDefaultTeamSettingsView,
} from './defaultRoutes';

export const routes: RouteRecordRaw[] = [
    {
        path: '/',
        name: 'dashboard',
        component: () => import('@/views/DashboardView.vue'),
        meta: {
            title: 'Dashboard',
            permissions: ['dashboard:read'],
        },
    },
    {
        path: '/analytics',
        name: 'analytics',
        component: () => import('@/views/AnalyticsView.vue'),
        meta: {
            title: 'Analytics',
            featureFlags: ['cashflow_analytics'],
            permissions: ['analytics:read'],
        },
    },
    {
        path: '/cards',
        name: 'cards',
        component: () => import('@/views/CardsView.vue'),
        meta: {
            title: 'Cards',
        },
    },
    {
        path: '/vendor-payments',
        name: 'vendorPayments',
        component: () => import('@/views/VendorPaymentsView.vue'),
        meta: {
            title: 'Vendor Payments',
        },
    },
    {
        path: '/invoice-payments',
        name: 'invoicePayments',
        component: () => import('@/views/InvoicePaymentsView.vue'),
        meta: {
            title: 'Invoice Payments',
        },
    },
    {
        path: '/capital',
        name: 'capital',
        component: () => import('@/views/CapitalView.vue'),
        meta: {
            title: 'Capital',
        },
    },
    {
        path: '/transactions',
        name: 'transactions',
        component: () => import('@/views/TransactionsView.vue'),
        meta: {
            title: 'Transactions',
            permissions: ['transaction:read'],
        },
    },
    {
        path: '/payments',
        name: 'payments',
        component: () => import('@/views/PaymentsView.vue'),
        meta: {
            title: 'Payments',
        },
    },
    {
        path: '/beneficiaries',
        name: 'beneficiaries',
        component: () => import('@/views/BeneficiariesView.vue'),
        meta: {
            title: 'Beneficiaries',
        },
    },
    {
        path: '/sadad',
        name: 'sadad',
        component: () => import('@/views/SadadView.vue'),
        meta: {
            title: 'SADAD',
            featureFlags: ['sadad'],
        },
    },
    {
        path: '/forbidden',
        name: 'forbidden',
        component: () => import('@/views/ForbiddenView.vue'),
        meta: {
            title: 'forbidden',
        },
    },
    {
        path: '/settings',
        name: 'settings',
        component: () => import('@/views/settings/SettingsIndex.vue'),
        meta: {
            title: 'Settings',
            permissions: ['member:write', 'role:write', 'approval-rule:write'],
            matchPermissionsStrategy: 'any',
        },
        beforeEnter: redirectToDefaultSettingsView,
        children: [
            {
                path: 'members/:memberId',
                name: 'memberProfile',
                component: () => import('@/views/settings/MemberProfile.vue'),
                meta: {
                    title: 'Member Profile',
                },
            },
            {
                path: 'team',
                name: 'teamSettings',
                meta: {
                    title: 'Team Settings',
                    permissions: ['member:write', 'role:write'],
                    matchPermissionsStrategy: 'any',
                },
                beforeEnter: redirectToDefaultTeamSettingsView,
                component: () => import('@/views/settings/TeamView.vue'),
                children: [
                    {
                        path: 'members',
                        name: 'teamMembers',
                        component: () =>
                            import('@/views/settings/TeamMembers.vue'),
                        meta: {
                            title: 'Team Members',
                            permissions: ['member:write'],
                        },
                    },
                    {
                        path: 'roles',
                        name: 'teamRoles',
                        component: () =>
                            import('@/views/settings/TeamRoles.vue'),
                        meta: {
                            title: 'Team Roles',
                            permissions: ['role:write'],
                        },
                    },
                    {
                        path: 'members/new',
                        name: 'newTeamMember',
                        component: () =>
                            import('@/views/settings/NewTeamMember.vue'),
                        meta: {
                            title: 'New Team Member',
                            permissions: ['member:write'],
                        },
                    },
                ],
            },
            {
                path: 'approval-rules',
                name: 'approvalRules',
                meta: {
                    title: 'Approval Rules',
                    permissions: ['approval-rule:write'],
                },
                redirect: '/settings/approval-rules/transfers',
                children: [
                    {
                        path: 'transfers',
                        name: 'approvalRulesTransfers',
                        component: () =>
                            import('@/views/settings/ApprovalRules.vue'),
                        meta: {
                            title: 'Approval Rules Transfers',
                        },
                    },
                    {
                        path: 'bills',
                        name: 'approvalRulesBills',
                        component: () =>
                            import('@/views/settings/ApprovalRules.vue'),
                        meta: {
                            title: 'Approval Rules Bills',
                        },
                    },
                ],
            },
        ],
    },
    {
        path: '/:pathMatch(.*)*',
        name: '404',
        component: () => import('@/views/NotFound.vue'),
        meta: {
            title: 'Not Found',
        },
    },
];
